import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  contentWrapper: theme => css`
    margin-top: ${theme.spacing.sm};
  `,

  inputWrapper: theme => css`
    margin: ${theme.spacing.xs} 0 ${theme.spacing.sm};
  `,

  copyToClipboardWrapper: theme => css`
    margin-bottom: ${theme.spacing.md};
  `,
})

export { useStyles }
